import * as React from "react";
import { getBackgroundColorClass } from "../../colors/index.mjs";
import { CookieConsentProvider } from "../../helpers/cookie-consent-provider/cookie-consent-provider.mjs";
import { HeaderProvider } from "../../helpers/header-provider/header-provider.mjs";
import { InputProvider } from "../../helpers/input-provider/input-provider.mjs";
const Main = (props) => {
  const { children, background, className, consent, consentEnabled, consentContent } = props;
  const BEM = () => {
    const classArray = ["main"];
    if (background) {
      classArray.push(getBackgroundColorClass(background));
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement(CookieConsentProvider, { consent, enabled: consentEnabled, content: consentContent }, /* @__PURE__ */ React.createElement(InputProvider, null, /* @__PURE__ */ React.createElement(HeaderProvider, null, /* @__PURE__ */ React.createElement("div", { className: BEM() }, /* @__PURE__ */ React.createElement("div", { className: "main__inner" }, children)))));
};
export {
  Main
};
